(function () {
  var root = document.querySelector('.challenge-page');
  if (!root) return;

  var params = new URLSearchParams(window.location.search);
  var campaign = params.get('campaign') || params.get('utm_source') || 'direct';
  campaign = /^[a-z0-9_-]{1,50}$/i.test(campaign) ? campaign.toLowerCase() : 'direct';
  try {
    if (campaign !== 'direct') sessionStorage.setItem('ftChallengeCampaign', campaign);
    else campaign = sessionStorage.getItem('ftChallengeCampaign') || 'direct';
  } catch (e) {}

  function track(eventName, details) {
    var data = Object.assign({campaign: campaign, page: 'challenge'}, details || {});
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      window.Shopify.analytics.publish(eventName, data);
    }
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({event: eventName}, data));
    }
  }

  track('challenge_page_viewed');
  if (campaign === 'qr') track('challenge_qr_visit');

  document.querySelectorAll('.challenge-enter').forEach(function (link) {
    link.addEventListener('click', function () { track('challenge_enter_clicked'); });
  });

  var form = document.getElementById('challenge-form');
  if (!form) return;
  var success = document.getElementById('challenge-success');
  if (success) {
    track('challenge_form_submitted');
    success.focus();
    return;
  }

  var campaignField = document.getElementById('challenge-campaign');
  if (campaignField) campaignField.value = campaign;
  var started = false;
  form.addEventListener('focusin', function () {
    if (!started) { started = true; track('challenge_form_started'); }
  });

  var fields = {posted: document.getElementById('challenge-post-link'), video: document.getElementById('challenge-video-link'), idea: document.getElementById('challenge-idea')};
  var eventNames = {posted: 'challenge_social_entry_selected', video: 'challenge_video_entry_selected', idea: 'challenge_idea_entry_selected'};
  form.querySelectorAll('input[name="contact[entry_type]"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      var selected = radio.value;
      form.querySelectorAll('.challenge-conditional').forEach(function (area) {
        area.hidden = area.getAttribute('data-entry-type') !== selected;
      });
      Object.keys(fields).forEach(function (type) { fields[type].required = type === selected; });
      track(eventNames[selected], {entry_type: selected});
    });
  });
  form.addEventListener('submit', function () {
    var type = form.querySelector('input[name="contact[entry_type]"]:checked');
    if (!type) return;
    var body = document.getElementById('challenge-body');
    var selectedField = fields[type.value];
    body.value = [
      'F*ckery Tower $500 Content Challenge entry',
      'Entry type: ' + type.value,
      'Campaign: ' + campaign,
      'Name: ' + document.getElementById('challenge-name').value,
      'Email: ' + document.getElementById('challenge-email').value,
      'Social handle: ' + document.getElementById('challenge-handle').value,
      'Submission: ' + (selectedField ? selectedField.value : '')
    ].join('\n');
    try { sessionStorage.setItem('ftChallengeCampaign', campaign); } catch (e) {}
  });
})();
